import { createColumnHelper } from "@tanstack/react-table";
import { useLocation } from "react-router-dom";
import {
  EditActionButton,
  ViewActionButton,
  PrintActionButton,
} from "../../../../../../components/common/primebmd-ui/EditActionButton";
import { ESRColumns } from "../utils/types";
import { useAuth } from "../../../../../../components/AuthProvider";
import { useSnackBar } from "../../../../../../components/ToastProvider";

export const useCreateESRWIPColumns = () => {
  const { showSnackBar } = useSnackBar();
  const currUser = useAuth();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const isApprovalModule = pathSegments[0] === "ejo-and-esr-approval";
  const hasESRManagementPermission =
    currUser &&
    currUser?.currentUserRole?.permissions.includes("ESR::MANAGEMENT");

  const canEdit = !isApprovalModule && hasESRManagementPermission;

  const handlePrint = (id?: string) => {
    if (!id) return;
    showSnackBar("PDF Preview started", "success");
    const url = `${process.env.REACT_APP_API_URL}esr/pdf/${id}`;
    window.open(url, "_blank");
  };

  const columnHelper = createColumnHelper<ESRColumns>();

  const esrWIPColumns = [
    columnHelper.accessor("esrNumber", {
      id: "esrNumber",
      header: "JO No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("equipmentNo", {
      id: "equipmentNo",
      header: "Equipment No.",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("projectLocation", {
      id: "projectLocation",
      header: "Project / Location",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    columnHelper.accessor("daysElapsed", {
      id: "daysElapsed",
      header: "Days Elapsed",
      cell: (row) => row.getValue(),
      enableGlobalFilter: true,
      enableColumnFilter: true,
    }),
    ...(canEdit
      ? [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <EditActionButton route={`complete/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => handlePrint(row.original.id)}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]
      : [
          columnHelper.display({
            id: "actions",
            header: "Action",
            cell: ({ row }) => (
              <>
                <ViewActionButton route={`view/${row.original.id}`} />
                <PrintActionButton
                  onClick={() => handlePrint(row.original.id)}
                />
              </>
            ),

            enableHiding: false,
          }),
        ]),
  ];

  return esrWIPColumns;
};
